import { Article } from '@api/api';
import { articleApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';
import { fetchArticles } from './useArticles';

export const fetchArticle = async (id: string, preview = false): Promise<Article> => {
  if (preview) {
    const [fetchedArticle] = await fetchArticles({
      id,
      _publicationState: 'preview',
      published_at_null: true,
    });

    return fetchedArticle;
  }

  const { data } = await articleApiClient.articlesIdGet({ id }, { params: { published_at: null } });

  return data;
};

export const useArticle = (
  id: string,
  preview = false,
  enabled = true,
): UseQueryResult<Article> => {
  return useQuery(['article', id], async () => fetchArticle(id, preview), { enabled });
};
